import * as actions from './focusActions'

const contentInit = {
	title: {},
	image: {},
	content: []
}
export default (state = contentInit, action) => {
	switch (action.type) {
		case actions.GET_FOCUS_SUCCESS:
			return {
				...state,
				title: action.title,
				image: action.image,
				content: action.content
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/focus/focusReducers.js